import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = ({ patientName = "John Doe", lastLogin = "2025-08-24" }) => {
  const getCurrentGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
  };

  return (
    <div className="bg-gradient-to-r from-primary to-primary/80 text-primary-foreground rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold mb-2">
            {getCurrentGreeting()}, {patientName}!
          </h1>
          <p className="text-primary-foreground/80 text-sm">
            Welcome back to your health dashboard. Last login: {lastLogin}
          </p>
        </div>
        <div className="hidden sm:flex items-center justify-center w-16 h-16 bg-primary-foreground/20 rounded-full">
          <Icon name="Heart" size={32} color="currentColor" />
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;